export default __webpack_public_path__ + "static/challenge-13b3c18715421a1e1ad04879f806b98b.webp";